import AppComponent from '@/App.vue'
import boot, {BootInfo} from '@/boot'
import {App, Context} from '@/project'
import router from '@/router'
import store from '@/store'
import {RouterMode} from 'vue-router'
import {VueConstructor} from 'vue'

interface AppOptions {
  env?: any
  routerMode?: RouterMode,
  [key: string]: any
}

interface BootstrapOptions {
  env?: any
}

/**
 * create base app data which add into new Vue(...)
 * @param Vue
 * @param options
 */
export const createApp = (Vue: VueConstructor, options: AppOptions = {}): App => {
  const {env = {}} = options
  return {
    store: store(Vue),
    router: router(Vue, options.routerMode),
    env,
  }
}

/**
 *
 * @param Vue what boot use
 * @param bootInfo this boot find files and add options by this info
 * @param options
 */
const bootstrap = async (
  Vue: VueConstructor,
  bootInfo: Array<BootInfo | string>,
  options: BootstrapOptions = {},
) => {
  const {env = {}} = options
  const app: App = createApp(Vue, {env})
  
  const context: Context = {
    Vue,
    app,
    store: app.store,
    router: app.router,
    message: {
      warn: (message) => {
        // eslint-disable-next-line no-console
        console.warn(message)
      },
    },
    env,
  }
  
  await boot(context, bootInfo)
  const vue = new Vue({
    ...app,
    render: (h) => (h(AppComponent)),
  })
  
  vue.$mount('#app')
  return {context, root: vue}
}

export default bootstrap
